// extracted by mini-css-extract-plugin
module.exports = {"typedWrapper":"HomeTyped_typedWrapper__QUTGA"};